/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ms-SliderBasicExample{max-width:300px}"}]);
/* tslint:enable */
